import { action } from "satcheljs";

export interface MARK_CONVERSATIONS_AS_READ_STORE_UPDATEActionMessage {
    conversationIds: string[];
    tableViewId: string;
    isReadValue: boolean;
    isExplicit: boolean;
}
const defaultExport: (conversationIds: string[], tableViewId: string, isReadValue: boolean, isExplicit: boolean) => MARK_CONVERSATIONS_AS_READ_STORE_UPDATEActionMessage = action("MARK_CONVERSATIONS_AS_READ_STORE_UPDATE", (conversationIds: string[], tableViewId: string, isReadValue: boolean, isExplicit: boolean): MARK_CONVERSATIONS_AS_READ_STORE_UPDATEActionMessage => {
    return {
        conversationIds,
        tableViewId,
        isReadValue,
        isExplicit,
    };
});
export default defaultExport;
